import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'
import globalCss from '../../../../scss/global.scss'
import { generateVariableKey } from '../../../utils'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'


export class BlankEditor extends Component {
  constructor ({ variable: { args } }) {
    super()
    const options = args[1] || []
    const useVariable = this.generateVarMap(options)

    this.state = {
      type: args[0] || '',
      randomize: args[2] || false,
      scoring: args[3] || 'exact',
      options,
      useVariable
    }
  }

  generateVarMap = (options) => {
    return options.reduce((useVar, next, index) => {
      useVar[index] = next.ref && next.ref.length

      return useVar
    }, {})
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    const { type, options, randomize, scoring } = this.state

    if (nextProps.report === true && report === false) {
      save(variableName, [type, options, randomize, scoring])
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { update } = this.props
    if (prevState !== this.state) {
      update()
    }
  }

  setType = evt => {
    const type = evt.target.value

    this.setState({ type })
  }

  generateVarOptions = () => {
    const { vars } = this.props
    const options = [
      <option key="empty" value="">Select variable...</option>
  ]

    for (const variableId in vars) {
      const variable = vars[variableId]
      if (variable.macro != 'blank') {
          options.push(
              <option key={`${variableId}`} value={variableId}>{variable.name}</option>
          )
      }
    }

    return options
}

  updateOption = (value, idx) => {
    const updatedOptions = [...this.state.options]

    updatedOptions[idx] = {
      ...updatedOptions[idx],
      text: value
    }

    this.setState({
      options: updatedOptions
    })
  }

  toggleCorrect = (value, idx) => {
    const updatedOptions = [...this.state.options]

    updatedOptions[idx] = {
      ...updatedOptions[idx],
      is_correct: !updatedOptions[idx].is_correct
    }

    this.setState({
      options: updatedOptions
    })
  }

  handleAddOption = () => {
    const { options, type } = this.state

    this.setState({
      options: [...options, {text: '', is_correct: type === 'short_answer'}]
    })
  }

  removeEntry (idx) {
    const options = [...this.state.options]
    options.splice(idx, 1)
    this.setState({
      options
    })
  }

  SegmentTypeSelector = () => {
    const { type } = this.state

    return (
      <select onChange={this.setType} value={type} className={ css.input }>
        <option value="">Choose a type</option>
        <option value="select">Select field</option>
        <option value="short_answer">Short answer field</option>
      </select>
    )
  }

  setRandomize = (evt) => {
    this.setState({
      randomize: evt.target.checked
    })
  }

  setScoring = (evt) => {
    this.setState({
      scoring: evt.target.value
    })
  }

  handleUseVariable = (index, value) => {
    const { options, useVariable } = this.state
    const useVariableUpdated = {
      ...useVariable,
      [index]: value
    }

    options[index].ref = ''
    options[index].text = ''

    this.setState({
      useVariable: useVariableUpdated,
      options
    })
  }

  setSelectedVar = (index, value) => {
    const { options } = this.state

    options[index].ref = value

    this.setState({
      options
    })
  }

  VariableSelector = (i) => {
    const varOptions = this.generateVarOptions()
    const { options } = this.state

    const option = options[i] || {}

    return (
      <span>
        <div>
          <label className={css.label}>
            Variable
          <span className={css.switch}>
            <button onClick={() => { this.handleUseVariable(i, false) }} className={css.switchBtn}>Use a manual value</button>
          </span>
          </label>
          <div className={css.backer}>
            <select className={css.input} value={option.ref} onChange={(evt) => { this.setSelectedVar(i, evt.target.value) }}>
              {varOptions}
            </select>
          </div>
        </div>
      </span>
    )
  }

  Selector = (option, i) => {
    const { useVariable } = this.state

    if (useVariable[i]) {
      return this.VariableSelector(i)
    }

    return (
      <span>
        <div>
          <label className={css.label}>
            Text

          <span className={css.switch}>
            <button onClick={() => { this.handleUseVariable(i, true) }} className={css.switchBtn}>Use a Variable</button>
          </span>
          </label>
          <input
            className={css.option}
            type='text'
            value={option.text}
            onChange={evt => { this.updateOption(evt.target.value, i) }}
            placeholder='Enter a value'
          />
        </div>
      </span>
    )
  }

  CorrectToggle = (option, i) => {
    return (
      <div>
        <label className={css.label}>
          <input
            type='checkbox'
            checked={option.is_correct}
            onChange={evt => { this.toggleCorrect(evt.target.value, i) }}
          /> Correct
        </label>
      </div>
    )
  }

  ChoiceList = () => {
    const { app: { primaryColor } } = this.props
    const { options } = this.state

    const choices = options.map((option, i) => {
      option.orderKey = option.orderKey ? option.orderKey : generateVariableKey()

      return (
        <Draggable draggableId={option.orderKey} index={i} key={`${i}_chunk`}>
          {(provided, snapshot) => (
            <li key={i} className={css.entry} {...provided.draggableProps} ref={provided.innerRef}>
              <span className={css.handle} {...provided.dragHandleProps}>
                <div className={css.bars} />
              </span>
              {this.Selector(option, i)}
              <button
                type='button'
                className={css.delete}
                onClick={() => this.removeEntry(i)}
              >
                Delete
              </button>
              {this.CorrectToggle(option, i)}
            </li>
          )}
        </Draggable>
      )
    })

    return (
      <div>
        <DragDropContext onDragEnd={this.handleOnDragEnd} onDragStart={this.handleOnDragStart}>
          <Droppable droppableId='options' type='OPTION'>
            {(provided, snapshot) => (
              <div
                className={css.Listing}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                <ul>
                  {choices}
                </ul>
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <button
          className={css.add}
          onClick={this.handleAddOption}
          type='button'
          className={ css.add }
        >
          <i className={globalCss.iconPlus} /> Add an option
        </button>
        <br />
      </div>
    )
  }

  handleOnDragEnd = result => {
    try {
      const { destination: { index: newIdx }, source: { index: oldIdx }, draggableId } = result
      const { options } = this.state
      const updatedOption = options.filter(option => option.orderKey === draggableId)[0]
      const updatedOptionOrder = [ ...options ]

      updatedOptionOrder.splice(oldIdx, 1)
      updatedOptionOrder.splice(newIdx, 0, updatedOption)

      const useVariable = this.generateVarMap(updatedOptionOrder)

      this.setState({ options: updatedOptionOrder, useVariable })
    } catch (error) {
      // NOOP
    }
  }

  handleOnDragStart = () => {
    document.activeElement.blur()
  }

  SegmentSettings = () => {
    const { type, randomize, scoring } = this.state

    switch (type) {
      case 'select': {
        return (<div>
          <label>
            <input type="checkbox" checked={randomize} onChange={this.setRandomize} />
            Randomize options when 
          </label>
        </div>)
      }
      case 'short_answer': {
        return (<div>
          <label>
            Scoring: 
            <select value={scoring} onChange={this.setScoring} className={ css.input }>
              <option value="exact">Exact</option>
              <option value="ignore_case">Ignore case</option>
              <option value="regex">Regular expression</option>
            </select>
          </label>
        </div>)
      }
      default: {
        return (null)
      }
    }
  }

  render () {
    const { type } = this.state
    const content = type ? this.ChoiceList(): null
    const settings = type ? this.SegmentSettings() : null

    return (
      <div>
        <div>
          <p>This is a blank variable type. It is only intended for use within the stem field.</p>
        </div>
        <div>
          {this.SegmentTypeSelector()}
        </div>

        <div>
          {content}
          {settings}
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app } = state
  return {
    app
  }
}

export default connect(mapStateToProps)(BlankEditor)



// WEBPACK FOOTER //
// /app/js/components/EditVariable/BlankEditor/index.js